import classNames from "classnames";
import React from "react";

import css from "./Table.module.scss";

export interface TableProps extends React.HTMLAttributes<HTMLTableElement> {
  sticky?: boolean;
}

export const Table = React.forwardRef<HTMLTableElement, TableProps>(
  ({ className, sticky, ...props }, ref) => (
    <table
      ref={ref}
      className={classNames(
        "g-table__table",
        css.table,
        sticky && css.tableStickyHeader,
        className,
      )}
      {...props}
    />
  ),
);

Table.displayName = "Table";
